import { Map, List, fromJS } from "immutable";
import actionTypes from "../../actions/actionTypes";
import requestStatus from "../../constants/requestStatus";
import { immutableAddItemToArray } from "../../functions/listsImmutable";


const INIT_STATE = Map({
    status: requestStatus.INITIALIZED,
    error: null,
    screens: Map({
        items: Map(),
        order: List()
    }),
    itemCollections: Map({
        items: Map()
    })
})

const onRequest = (state, action)   => state.set('status', requestStatus.REQUEST_PENDING)
                                            .set('error', '')

const onError = (state, action)     => state.set('status', requestStatus.REQUEST_ERROR)
                                            .set('error', action.payload.errorMessage)

const onSuccess = (state, action)   => state.set('status', requestStatus.REQUEST_SUCCESS)
                                            .set('error', '')


const onCreateItem = (state, action, key, hasOrder) => {
    if(hasOrder) {
        const newOrder = immutableAddItemToArray(state.getIn([key, 'order']), action.payload.pk)
        state = state.setIn([key, 'order'], newOrder)
    }

    return state.setIn([key, 'items', action.payload.pk], fromJS(action.payload.data))
}

const onUpdateItem = (state, action, key) => {
    return state.mergeIn([key, 'items', action.payload.pk], fromJS(action.payload.data))
}

const onDeleteItem = (state, action, key) => {
    return state.deleteIn([key, 'items', action.payload.pk])
}


const signageReducer = (state = INIT_STATE, action) => {
    switch(action.type) {
        case actionTypes.SIGNAGE_SCREEN_CREATE_REQUEST:
            return onRequest(state, action)
        case actionTypes.SIGNAGE_SCREEN_CREATE_SUCCESS:
            return onSuccess(state, action)
        case actionTypes.SIGNAGE_SCREEN_CREATE_ERROR:
            return onError(state, action)

        case actionTypes.SIGNAGE_SCREEN_CREATE:
            return onCreateItem(state, action, 'screens', true)
        case actionTypes.SIGNAGE_SCREEN_UPDATE:
            return onUpdateItem(state, action, 'screens', false)

        case actionTypes.SIGNAGE_COLLECTION_CREATE:
            return onCreateItem(state, action, 'itemCollections', false)
        case actionTypes.SIGNAGE_COLLECTION_UPDATE:
            return onUpdateItem(state, action, 'itemCollections')
        case actionTypes.SIGNAGE_COLLECTION_DELETE:
            return onDeleteItem(state, action, 'itemCollections')
        default:
            return state
    }
}

export default signageReducer